import React, {useEffect, useRef, useState} from "react";
import AdminSidebar from "../components/sidebar/admin_sidebar";
import PageTitle from "../../../components/page_title/page_title";
import axiosInstance from "../../../AxiosInstance";
import styles from "../../settings/styles/settings.module.css";
import sidebarStyles from "../components/sidebar/admin_sidebar.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faTrash, faSearch, faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/modal/modal";
import {SecondaryButton, SelectInput, TextInput} from "../../../components/input/inputs";
import QRCode from "react-qr-code";
import {useTranslation} from "react-i18next";

const PAGE_SIZE = 10;

function Popup({currentDeviceType, setShowPopup, setShowDeleteModal, setDeviceTypeToDelete}) {
    const {t} = useTranslation();

    const gotoMQTTConfig = () => {
        localStorage.setItem('currentDeviceType', JSON.stringify(currentDeviceType));
        window.location.href = `/admin/device_types/mqtt_config`;
    };

    const handleDeleteClick = () => {
        setShowPopup(false);
        setDeviceTypeToDelete(currentDeviceType);
        setShowDeleteModal(true);
    };

    return (
        <div style={{width: '200px', height: 'auto'}}>
            <div className={styles.popupButton} onClick={() => {
                setShowPopup(false);
                gotoMQTTConfig();
            }}>
                <FontAwesomeIcon icon={faEdit} color={'#64748B'} className={'me-2'}/>
                <div style={{color: '#334155'}}>{t('adminDeviceTypes.configure')}</div>
            </div>
            <div className={styles.popupButton} onClick={handleDeleteClick}>
                <FontAwesomeIcon icon={faTrash} color={'#ef4444'} className={'me-2'}/>
                <div style={{color: '#dc2626'}}>{t('adminDeviceTypes.delete')}</div>
            </div>
        </div>
    );
}

export default function ListDeviceTypes() {
    const {t} = useTranslation();
    const [rows, setRows] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [mousePosition, setMousePosition] = useState({x: null, y: null});
    const popupRef = useRef(null);
    const [currentDeviceType, setCurrentDeviceType] = useState({});
    const [showQRModal, setShowQRModal] = useState(false);
    const [qrForm, setQrForm] = useState({});
    const [qrValue, setQrValue] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deviceTypeToDelete, setDeviceTypeToDelete] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        axiosInstance.get('device_type/').then((res) => {
            setRows(res.data.results);
        });
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const handleOutsideClick = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setShowPopup(false);
        }
    };

    useEffect(() => {
        if (showPopup) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [showPopup]);

    useEffect(() => {
        const final = qrForm.DEV_EUI + ";" + qrForm.APP_KEY + ";" + qrForm.APP_EUI + ";" + qrForm.type;
        setQrValue(final);
    }, [qrForm]);

    const createNewDeviceType = () => {
        axiosInstance.post('device_type/', {name: 'New Device'}).then((res) => {
            localStorage.setItem('currentDeviceType', JSON.stringify(res.data));
            window.location.href = '/admin/device_types/mqtt_config';
        });
    };

    const confirmDeleteDeviceType = () => {
        axiosInstance.delete(`device_type/${deviceTypeToDelete.id}/`).then(() => {
            setShowDeleteModal(false);
            setDeviceTypeToDelete(null);
            window.location.reload();
        }).catch(() => {
            alert(t('adminDeviceTypes.errorDeleting'));
        });
    };

    const filtered = rows.filter(r =>
        r.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    const safePage = Math.min(currentPage, totalPages);
    const from = (safePage - 1) * PAGE_SIZE;
    const pageRows = filtered.slice(from, from + PAGE_SIZE);

    return (
        <div className={sidebarStyles.adminContent}>
            <AdminSidebar active={1}/>

            <Modal show={showQRModal} setter={setShowQRModal} name={t('adminDeviceTypes.generateQr')} buttonName={t('common.ok')} onClick={() => setShowQRModal(false)}>
                <div className={'mb-3'}>
                    <SelectInput name={'type'} options={rows} form={qrForm} setForm={setQrForm}/>
                </div>
                <TextInput name={'DEV_EUI'} setForm={setQrForm} form={qrForm}/>
                <TextInput name={'APP_KEY'} setForm={setQrForm} form={qrForm}/>
                <TextInput name={'APP_EUI'} setForm={setQrForm} form={qrForm}/>
                <div className={'mt-3 justify-content-center d-flex'}>
                    <QRCode value={qrValue}/>
                </div>
            </Modal>

            <Modal show={showDeleteModal} setter={setShowDeleteModal} name={t('adminDeviceTypes.deleteDeviceType')} buttonName={t('adminDeviceTypes.delete')} onClick={confirmDeleteDeviceType}>
                <div className={'text-center'}>
                    <p>{t('adminDeviceTypes.deleteConfirmDeviceType')}</p>
                    <p className={'fw-bold fs-5'}>{deviceTypeToDelete?.name}</p>
                    <p className={'text-muted'}>This action cannot be undone.</p>
                </div>
            </Modal>

            {showPopup &&
                <div ref={popupRef} className={styles.popUpModule} style={{top: mousePosition.y + 15, left: mousePosition.x - 180, position: 'absolute', zIndex: '100000'}}>
                    <Popup currentDeviceType={currentDeviceType} setShowPopup={setShowPopup} setShowDeleteModal={setShowDeleteModal} setDeviceTypeToDelete={setDeviceTypeToDelete}/>
                </div>
            }

            <div className={'mx-5'}>
                <PageTitle title={t('adminDeviceTypes.title')} createName={'Device Type'} openModal={createNewDeviceType}>
                    <div className={'pe-2'}>
                        <SecondaryButton name={t('adminDeviceTypes.generateQr')} onClick={() => setShowQRModal(true)}/>
                    </div>
                </PageTitle>

                {/* Search bar */}
                <div style={{display: 'flex', alignItems: 'center', gap: '10px', background: '#fff', border: '1px solid #E2E8F0', borderRadius: '8px', padding: '10px 16px', maxWidth: '400px', marginTop: '20px'}}>
                    <FontAwesomeIcon icon={faSearch} style={{color: '#64748B', fontSize: '14px'}}/>
                    <input
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        placeholder={t('adminDeviceTypes.searchPlaceholder')}
                        style={{border: 'none', outline: 'none', flex: 1, fontSize: '14px', color: '#1E293B'}}
                    />
                </div>

                {/* Table */}
                <div style={{marginTop: '16px', background: '#fff', borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden'}}>
                    <table style={{width: '100%', borderCollapse: 'collapse'}}>
                        <thead>
                            <tr style={{background: '#F8FAFC'}}>
                                <th style={thStyle}>ID</th>
                                <th style={thStyle}>{t('common.name')}</th>
                                <th style={{...thStyle, textAlign: 'center'}}>Is Encrypted</th>
                                <th style={{...thStyle, textAlign: 'center'}}>{t('common.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pageRows.length === 0 ? (
                                <tr>
                                    <td colSpan={4} style={{padding: '32px', textAlign: 'center', color: '#94A3B8', fontSize: '14px'}}>
                                        {t('common.noResults')}
                                    </td>
                                </tr>
                            ) : pageRows.map((row, i) => (
                                <tr key={row.id} style={{borderTop: '1px solid #F1F5F9'}}>
                                    <td style={tdStyle}>{row.id}</td>
                                    <td style={tdStyle}>{row.name}</td>
                                    <td style={{...tdStyle, textAlign: 'center'}}>
                                        <span style={{
                                            display: 'inline-block', padding: '2px 10px', borderRadius: '10px', fontSize: '12px', fontWeight: '500',
                                            background: row.is_encrypted ? '#F0FDF4' : '#F8FAFC',
                                            color: row.is_encrypted ? '#16A34A' : '#94A3B8',
                                        }}>
                                            {row.is_encrypted ? t('common.yes') : t('common.no')}
                                        </span>
                                    </td>
                                    <td style={{...tdStyle, textAlign: 'center'}}>
                                        <div
                                            className={`d-flex flex-row justify-content-center align-items-center ps-3 ${styles.editButton}`}
                                            onClick={(event) => {
                                                setShowPopup(true);
                                                setMousePosition({x: event.clientX, y: event.clientY});
                                                setCurrentDeviceType(row);
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    {filtered.length > 0 && (
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', borderTop: '1px solid #F1F5F9'}}>
                            <span style={{fontSize: '13px', color: '#64748B'}}>
                                {t('common.showingOf', {from: from + 1, to: Math.min(from + PAGE_SIZE, filtered.length), total: filtered.length})}
                            </span>
                            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                <button
                                    onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                    disabled={safePage === 1}
                                    style={paginationBtnStyle(safePage === 1)}
                                >
                                    <FontAwesomeIcon icon={faChevronLeft} style={{fontSize: '11px'}}/>
                                    {t('common.previous')}
                                </button>

                                {Array.from({length: totalPages}, (_, i) => i + 1)
                                    .filter(p => p === 1 || p === totalPages || Math.abs(p - safePage) <= 1)
                                    .reduce((acc, p, idx, arr) => {
                                        if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
                                        acc.push(p);
                                        return acc;
                                    }, [])
                                    .map((p, i) => p === '...'
                                        ? <span key={`ellipsis-${i}`} style={{color: '#94A3B8', fontSize: '13px', padding: '0 4px'}}>…</span>
                                        : <button key={p} onClick={() => setCurrentPage(p)} style={pageNumberStyle(p === safePage)}>{p}</button>
                                    )
                                }

                                <button
                                    onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                    disabled={safePage === totalPages}
                                    style={paginationBtnStyle(safePage === totalPages)}
                                >
                                    {t('common.next')}
                                    <FontAwesomeIcon icon={faChevronRight} style={{fontSize: '11px'}}/>
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

const thStyle = {
    padding: '12px 16px',
    fontSize: '13px',
    fontWeight: '600',
    color: '#64748B',
    textAlign: 'left',
    whiteSpace: 'nowrap',
};

const tdStyle = {
    padding: '12px 16px',
    fontSize: '14px',
    color: '#334155',
};

const paginationBtnStyle = (disabled) => ({
    display: 'flex', alignItems: 'center', gap: '6px',
    padding: '6px 12px', borderRadius: '6px', fontSize: '13px',
    border: '1px solid #E2E8F0', background: disabled ? '#F8FAFC' : '#fff',
    color: disabled ? '#CBD5E1' : '#475569', cursor: disabled ? 'default' : 'pointer',
    fontWeight: '500',
});

const pageNumberStyle = (active) => ({
    width: '32px', height: '32px', borderRadius: '6px', fontSize: '13px', fontWeight: '500',
    border: `1px solid ${active ? '#C7D2FE' : '#E2E8F0'}`,
    background: active ? '#EEF2FF' : '#fff',
    color: active ? '#4F46E5' : '#475569',
    cursor: 'pointer',
});
